import { ElMessage, ElLoading } from 'element-plus';
import CompilationsApi from '@/frontend/api/compilations';
import { mapGetters } from 'vuex';
import { EditPen, Link } from '@element-plus/icons-vue';
export default {
  name: "ProfileCompilationsPage",
  components: {
    EditPen,
    Link
  },

  data() {
    return {
      Compilations: [],
      pathToCompilation: ''
    };
  },

  computed: { ...mapGetters(['user'])
  },
  methods: {
    handlerCopy(link) {
      try {
        navigator.clipboard.writeText(link).then(() => ElMessage({
          message: 'Ссылка скопирована',
          type: 'success'
        }));
      } catch (e) {
        ElMessage({
          message: 'Ошибка при копировании. Проверьте наличие протокола https',
          type: 'error'
        });
      }
    }

  },

  created() {
    this.$router.getRoutes().some(item => {
      if (item.name !== 'compilation') return false;
      this.pathToCompilation = window.location.origin + item.path;
      return true;
    });
  },

  beforeMount() {
    let loader = ElLoading.service({
      lock: false,
      text: 'Загрузка'
    });
    CompilationsApi.get({
      'filter[userId]': this.user('id'),
      'filter[status_id][gte]': 0,
      'expand': ['users'].join(',')
    }).then(response => {
      this.Compilations = response.items;
      this.Compilations.forEach(item => {
        item.accessLink = this.pathToCompilation.replace(':id', item.access_link);
      });
    }).catch(error => {
      ElMessage.error('Неизвестная ошибка');
      console.log(error);
    }).finally(() => {
      loader.close();
    });
  }

};